import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") return;

    const scrollTargets = [
      window,
      document.scrollingElement,
      document.documentElement,
      document.body,
      document.querySelector(".main_layout_content"),
      document.querySelector(".main_content_wrap"),
    ].filter(Boolean);

    const scrollToTop = () => {
      scrollTargets.forEach((target) => {
        if (typeof target.scrollTo === "function") {
          target.scrollTo({ top: 0, left: 0 });
        } else if ("scrollTop" in target) {
          target.scrollTop = 0;
        }
      });
    };

    scrollToTop();
    const rafId = window.requestAnimationFrame(scrollToTop);
    return () => window.cancelAnimationFrame(rafId);
  }, [location.pathname, location.search]);

  return null;
};

export default ScrollToTop;
